var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargingReportsUiInvoice2Small(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,21V3c0-1.6542969-1.3457031-3-3-3H6C4.3457031,0,3,1.3457031,3,3v18c0,1.6542969,1.3457031,3,3,3h12 C19.6542969,24,21,22.6542969,21,21z M5,21V3c0-0.5517578,0.4482422-1,1-1h12c0.5517578,0,1,0.4482422,1,1v18 c0,0.5517578-0.4482422,1-1,1H6C5.4482422,22,5,21.5517578,5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,8h-3v2h3c0.5517578,0,1,0.4482422,1,1v18c0,0.5517578-0.4482422,1-1,1H14c-0.5517578,0-1-0.4482422-1-1v-3h-2v3 c0,1.6542969,1.3457031,3,3,3h12c1.6542969,0,3-1.3457031,3-3V11C29,9.3457031,27.6542969,8,26,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11h-4.1318359l2.9638672-4.4453125l-1.6640625-1.109375l-4,6 c-0.2041016,0.3066406-0.2236328,0.7011719-0.0498047,1.0263672S8.6308594,13,9,13h4.1318359l-2.9638672,4.4453125 l1.6640625,1.109375l4-6c0.2041016-0.3066406,0.2236328-0.7011719,0.0498047-1.0263672S15.3691406,11,15,11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingReportsUiInvoice2Small);
export default __webpack_public_path__ + "static/media/charging-reports-ui-invoice-2--small.f7dfbac5930b76e4ea78c9e37d737ea2.svg";
export { ForwardRef as ReactComponent };